import React from 'react'
import { Field } from 'formik'
import { Form, Col } from '_zari/core'

const ModeloFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='MODELO' htmlFor='input-modelo' md={3} alignRightAt='md' />
      <Col md={9}>
        <Field name='modelo'>
          {({ field }) => (
            <Form.InputText
              {...field}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              id='input-modelo'
              placeholder='Modelo del producto'
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(ModeloFormGroup)
